import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { IOrganization } from "store/organizationProfile";
import { Link } from "react-router-dom";
import useCustomBranding from "hooks/useCustomBranding";


export const ProgramListingCard = () => {
  const organizationProfile = useSelector<RootState, IOrganization>(
    (state) => state?.organizationProfile
  );
  const { getBrandPlaceholder } = useCustomBranding();
  return (
    <div className="flex flex-col w-full rounded-lg shadow-md lg:p-4 xl:p-6 bg-bgWhite dark:bg-secondaryLight dark:border dark:border-lineLight hover:shadow-xl">
      <div className="flex justify-between w-full mb-1">
        <p className="text-base font-semibold dark:text-textMain">{`${organizationProfile?.noOfPrograms} ${
          organizationProfile.noOfPrograms > 1 ? "Programs" : "Program"
        } `}</p>

        <Link
          to={`/organizations/${organizationProfile?.id}/programs`}
          className="flex-grow-0 flex-shrink-0 "
        >
          <p className="text-sm font-semibold text-primary dark:text-primaryMidLight hover:text-primaryMid ">
            Manage All
          </p>
        </Link>
      </div>

      {organizationProfile?.programs
        .slice(0, 5)
        ?.map((program: any, index: number) => {
          return (
            <div key={index} className="flex mt-4">
              <div className="w-8">
              <div className="w-8 h-8 mt-2 rounded-full">
                <img
                  src={
                    program?.profileImage?.file?.thumb
                      ? program?.profileImage?.file?.thumb
                      : getBrandPlaceholder("listingProfile")
                  }
                  alt={program?.name}
                  className="w-full rounded-full"
                />
              </div>
              </div>
              <div className="ml-4">
                <p className="text-[15px] dark:text-textMain break-words break-all">
                  {program?.name}
                </p>

                <div>
                  {program.programCode && (
                    <span className="text-xs dark:text-caption ">
                      Code: {program.programCode}
                    </span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};
